import { Store } from 'vuex'

export default (store: Store<KwixeoInterface.AnyValue>): KwixeoInterface.BroadcastListens => ([
  {
    name: '.SenderCreated',
    callback: (sender: KwixeoCommunication.Sender): void => {
      store.dispatch('communication/setSender', sender)
    }
  },
  {
    name: '.SenderUpdated',
    callback: (sender: KwixeoCommunication.Sender): void => {
      store.dispatch('communication/setSender', sender)
    }
  },
  {
    name: '.SenderDeleted',
    callback: (sender: KwixeoCommunication.Sender): void => {
      store.dispatch('communication/deleteSender', sender)
    }
  }

])
